<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Komisi" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <!-- @include('blocks.page-content-header') -->
          <Alert
            v-if="syncSuccess"
            :alert="{
              title: 'Sinkronisasi berhasil',
              type: 'success',
              content: `Berhasil melakukan sinkronisasi data`,
            }"
          />
          <Alert
            v-if="syncFailed"
            :alert="{
              title: 'Sinkronisasi gagal',
              type: 'danger',
              content: `Gagal melakukan sinkronisasi data`,
            }"
          />
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />

          <div class="card card-filter-sort no-print mb-3">
            <div class="row">
              <div class="col-md-10">
                <FormRow
                  :row="filters"
                  @handleChange="(e) => handleChange(e)"
                />
              </div>
              <div class="col-md-2">
                <FormRow :row="sort" @handleChange="(e) => handleChange(e)" />
              </div>
            </div>
          </div>
          <div class="table-responsive">
            <div class="row" v-if="rows && rows.length">
              <div class="col-md-3">
                <div class="row form-group mt-3">
                  <div class="col-md-12 d-flex flex-between">
                    <label class="mb-0 mr-3">Tampilkan</label>
                    <select class="form-control" v-model="perPage">
                      <option value="10">10 data</option>
                      <option v-if="rows.length > 10" value="25">
                        25 data
                      </option>
                      <option v-if="rows.length > 25" value="50">
                        50 data
                      </option>
                      <option v-if="rows.length > 50" value="100">
                        100 data
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-md-6 offset-md-3">
                <div class="form-group mt-3">
                  <input
                    type="text"
                    class="form-control with-icon-left without-label"
                    v-model="filter"
                    placeholder="Cari data di sini"
                    ref="focusMe"
                    @keydown="$event.stopImmediatePropagation()"
                  />
                  <i class="material-symbols-outlined">search</i>
                </div>
              </div>
            </div>
            <datatable
              v-if="loaded && rows.length"
              :columns="columns"
              :per-page="parseInt(perPage)"
              :data="rows"
              :filter="filter"
              class="table table-hover responsive"
            ></datatable>
            <EmptyState
              v-else-if="loaded && !rows.length"
              :data="{
                img: '/img/med.svg',
                size: 'small',
                title: `Tidak ada data komisi dengan filter di atas'`,
                content:
                  'Generate Komisi dengan mengeklik tombol + Generate Komisi di atas',
              }"
            />
            <Loading v-else />
            <br />
            <p v-if="rows.length">
              Menampilkan
              {{ countTotalRows }} data dari total {{ rows.length }} data
            </p>
            <datatable-pager
              v-if="loaded && rows.length"
              v-model="page"
              class="nav nav-tabs datatable-pager"
              type="abbreviated"
            ></datatable-pager>
          </div>
        </div>
      </div>
    </div>
    <button
      v-for="row in rows"
      v-bind:key="row.id + String(Math.random(1023))"
      :id="'cancel' + row.id"
      @click="
        () => {
          cancel(row.id, `${row.no_rawat} | ${row.no_rm} - ${row.pasien.nama}`);
        }
      "
      style="display: none"
    ></button>
    <div class="modal modal-confirm" id="modalDelete" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <!--  <h5 class="modal-title">Modal title</h5>  -->
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <!-- <h3 class="confirm-title">Delete Confirmation</h3> -->
            <img
              class="img-illustration delete-alert mb-0"
              src="/img/alert-triangle.svg"
              style="width: 40%"
            />
            <p class="confirm-content mb-2">
              Apakah Anda yakin untuk membatalkan pemeriksaan berikut?
            </p>
            <h4>{{ cancelItem.name }}</h4>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-danger"
              data-dismiss="modal"
            >
              TIDAK
            </button>
            <button
              id="btncancelItem"
              class="btn btn-danger"
              @click="
                () => {
                  confirmCancel(cancelItem.id);
                }
              "
              data-dismiss="modal"
            >
              YA
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Loading from "@/components/Loading.vue";
import Alert from "@/components/Alert.vue";
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
import EmptyState from "@/components/EmptyState.vue";
// import { HTTP } from "@/config.js";
import { data, tabs, filters, sort } from "@/data/Komisi.js";
import { getInputDate } from "@/data/helper.js";
//import jQuery from 'jquery';
//import bootstrap from '@/vendor/bootstrap.js';
export default {
  name: "Komisi",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    FormRow,
    Loading,
    Alert,
    EmptyState,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      syncSuccess: false,
      syncFailed: false,
      cancelItem: { id: null, name: "" },
      loaded: false,
      data: data,
      filters: filters,
      sort: sort,
      tabs: tabs,
      created_at: "",
      orderBy: "desc",
      id_periode: "",
      darurat: 0,
      model_penerima: "App\\Models\\Dokter",
      allDokter: [],
      allPetugas: [],
      columns: [
        {
          label: "No",
          field: "number",
        },
        { label: "Periode", field: "periode.nama" },
        { label: "Awal Periode", field: "periode.formatted_awal" },
        { label: "Akhir Periode", field: "periode.formatted_akhir" },
        { label: "Nama Pegawai", field: "penerima.formatted_nama_2" },
        { label: "Total Komisi", field: "formatted_total" },
        {
          label: "",
          class: "dropdown",
          representedAs: (data) => {
            return `<a class="btn btn-sm btn-success btn-icon" href="/#/komisi/detail/${data.id}"><i class="material-symbols-outlined">open_in_new</i></a>
            <a class="btn btn-sm btn-secondary btn-icon" href="/#/komisi/form/${data.id}"><i class="material-symbols-outlined">create</i></a>`;
          },
          interpolate: true,
        },
        // {label: 'Address', representedAs: ({address, city, state}) => `${address}<br />${city}, ${state}`, interpolate: true}
      ],
      filter: "",
      page: 1,
      countTotalRows: 0,
      perPage: 10,
      rows: [],
    };
  },
  methods: {
    countRows() {
      let that = this;
      setInterval(function() {
        let count = document.querySelectorAll(
          ".table-responsive table.responsive tbody>tr"
        ).length;
        if (that.countTotalRows != count) {
          that.countTotalRows = count;
        }
      }, 1000);
    },
    async filterTab(filter) {
      //console.log(filter);
      this["status"] = filter;
      await this.displayList();
      this.$nextTick(() => {
        if (this.$refs.focusMe) {
          this.$refs.focusMe.focus();
        }
      });
    },
    async handleChange(e) {
      this[e.target.name] = e.target.value;
      //console.log(`${e.target.name}:${this[e.target.name]}`);
      await this.displayList();
      // this.$nextTick(() => {
      //   if (this.$refs.focusMe) {
      //     this.$refs.focusMe.focus();
      //   }
      // });
    },
    getAllData: async function(model) {
      let model_penerima = `App\\Models\\${model}`;
      this.errors = [];
      try {
        let params = "per_page=999999999999999999&";
        params += `model_penerima=${model_penerima}&`;
        let result = await this.$store.state.HTTP.get(
          `komisi_ringkasan?${params}`
        );
        //console.log(result);
        if (result.status == "200") {
          this[`all${model}`] = result.data.data;
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        this.errors.push(e);
      }
    },
    displayList: async function() {
      this.loaded = false;
      this.errors = [];
      try {
        let params = "per_page=999999999999999999&";
        if (this.model_penerima) {
          params += `model_penerima=${this.model_penerima}&`;
        }
        if (this.id_periode) {
          params += `id_periode=${this.id_periode}&`;
        }
        if (this.orderBy) {
          params += `orderBy=${this.orderBy}`;
        }
        let result = await this.$store.state.HTTP.get(
          `komisi_ringkasan?${params}`
        );
        //console.log(result);
        //console.log(params);
        if (result.status == "200") {
          //console.log("berhasil");
          this.rows = result.data.data.map((item, index) => {
            item.number = index + 1;
            return item;
          });
          this.loaded = true;
          //console.log(this.rows);
        } else {
          //console.log(result.status);
          this.errors.push(result.status);
          this.loaded = true;
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
        this.loaded = true;
      }
    },
    fetchPeriods: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          "periode?per_page=9999999999"
        );
        //console.log(result);
        if (result.status == "200") {
          let periods = result.data.data;
          this.filters.columns[0].options = periods.map(function(item) {
            item.label = `${item.nama}`;
            item.value = item.id;
            return { label: item.label, value: item.value };
          });
        } else {
          this.displayNotFoundError();
        }
      } catch (e) {
        //console.log(e);
      }
    },
    cancel: async function(id, name) {
      this.cancelItem = {
        id: id,
        name: name,
      };
    },
    async confirmCancel(id) {
      //console.log(id);
      let result = await this.$store.state.HTTP.put(
        `ralan/${id}`,
        `status=DIBATALKAN`
      );
      //console.log(result);
      if (result.status == 200) {
        this.cancelSuccess = true;
        await this.displayList();
        this.$nextTick(() => {
          if (this.$refs.focusMe) {
            this.$refs.focusMe.focus();
          }
        });
      } else {
        this.cancelFailed = true;
      }
      this.resetAlert();
    },
    sync: async function() {
      // let resultHris = await this.$store.state.HTTP_HRIS.get('payroll/get-total',{
      //   "date_start":"2021-03-01","date_end":"2021-03-31"
      // });
      //console.log(resultHris);
      let success = true;
      let today = getInputDate();
      //console.log(today);
      //console.log(this.allDokter);
      //console.log(this.allPetugas);
      let dokterByPeriod = [];
      let petugasByPeriod = [];
      this.allDokter.forEach((item) => {
        //console.log(item.id_periode);
        let found = dokterByPeriod.find((itr) => {
          return "DOK-" + item.id_periode == itr.kode;
        });
        if (found) {
          found.items.push({
            catatan: "Komisi untuk " + item.penerima.formatted_nama_2,
            subtotal: item.total,
          });
        } else {
          dokterByPeriod.push({
            kategori: "Dokter General",
            kode: "DOK-" + item.id_periode,
            tanggal: today,
            deskripsi:
              "[Dokter] Pengeluaran untuk Komisi Dokter Periode " +
              item.periode.formatted_nama,
            isGiroMundur: 0,
            items: [
              {
                catatan: "Komisi untuk " + item.penerima.formatted_nama_2,
                subtotal: item.total,
              },
            ],
          });
        }
      });
      this.allPetugas.forEach((item) => {
        //console.log(item.id_periode);
        let found = petugasByPeriod.find((itr) => {
          return "PTG-" + item.id_periode == itr.kode;
        });
        if (found) {
          found.items.push({
            catatan: "Komisi untuk " + item.penerima.formatted_nama_2,
            subtotal: item.total,
          });
        } else {
          petugasByPeriod.push({
            kategori: "Pegawai General",
            kode: "PTG-" + item.id_periode,
            tanggal: today,
            deskripsi:
              "[Petugas] Pengeluaran untuk Komisi Petugas Periode " +
              item.periode.formatted_nama,
            isGiroMundur: 0,
            items: [
              {
                catatan: "Komisi untuk " + item.penerima.formatted_nama_2,
                subtotal: item.total,
              },
            ],
          });
        }
      });

      //console.log(dokterByPeriod);
      //console.log(petugasByPeriod);
      for (const item of dokterByPeriod) {
        //console.log(item);
        let result = await this.$store.state.HTTP_SIAKUN.post(
          "kas-bank/pengeluaran/tambah-gaji-simrs",
          item
        );
        if (result.status == "200") {
          //console.log('berhasil menyimpan komisi dokter ke siakun');
        } else {
          success = false;
        }
      }
      for (const item of petugasByPeriod) {
        //console.log(item);
        let result = await this.$store.state.HTTP_SIAKUN.post(
          "kas-bank/pengeluaran/tambah-gaji-simrs",
          item
        );
        if (result.status == "200") {
          //console.log('berhasil menyimpan komisi petugas ke siakun');
        } else {
          success = false;
        }
      }

      if (success) {
        this.syncSuccess = true;
        await this.displayList();
        this.$nextTick(() => {
          if (this.$refs.focusMe) {
            this.$refs.focusMe.focus();
          }
        });
      } else {
        this.syncFailed = true;
      }
      this.resetAlert();
    },
    resetAlert() {
      let self = this;
      setTimeout(function() {
        self.cancelSuccess = false;
        self.cancelFailed = false;
      }, 5000);
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    this.countRows();
    this.fetchPeriods();
    await this.displayList();
    this.$nextTick(() => {
      if (this.$refs.focusMe) {
        this.$refs.focusMe.focus();
      }
    });
    this.data.actionBtn = [
      {
        class: "btn-outline-secondary  btn-with-icon-left",
        label: "Sync",
        type: "function",
        function: this.sync,
        iconLeft: "sync",
      },
      this.data.actionBtn[this.data.actionBtn.length - 1],
    ];
    this.getAllData("Dokter");
    this.getAllData("Petugas");
  },
};
</script>
